/**
 * When sidenav has a lot of components inside (for example a schema test
 * with 100+ columns), opening a sidebar leads to unresponsive interface (probably
 * because of animations during "heavy" content rendering). This delay is aimed
 * to delay the content rendering on sidebar opening.
 */
export const SIDENAV_CONTENT_RENDER_DELAY_MS = 250;
